<template>
  <div class="facts">
    <div class="facts__bg"></div>

    <div class="facts__right">
      <div>
        <div class="h1">
          <div>{{'factsTitle1' | localize}} &nbsp;</div>
          <div>{{'factsTitle2' | localize}} &nbsp;</div>
          <div>{{'factsTitle3' | localize}} &nbsp;</div>
        </div>
        <p>{{'factsDescription' | localize}}</p>

        <div class="facts__wrap">
          <div class="facts__item">
            <h2 class="text-bg-yellow">
              {{'more' | localize}}
              <span>{{projects}}</span>
            </h2>
            <p>{{'fact1' | localize}}</p>
          </div>
          <div class="facts__item">
            <h2 class="text-bg-purple">
              {{'more' | localize}}
              <span>30</span>
            </h2>
            <p>{{'fact2' | localize}}</p>
          </div>
          <div class="facts__item">
            <h2 class="text-bg-blue">
              <span>{{year}}</span>
              {{'years' | localize}}
            </h2>
            <p>{{'fact3' | localize}}</p>
          </div>
          <div class="facts__item">
            <h2 class="text-bg-pink">
              <span>7</span>
              {{'contries' | localize}}
            </h2>
            <p>{{'fact4' | localize}}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Facts",
  props: {},
  computed: {
    projects() {
      return (this.year * 5.55).toFixed(0);
    },
    year() {
      return new Date().getUTCFullYear() - 2011;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.facts {
  position: relative;
  width: 100vw;
  height: 76vh;
  min-height: 988px;
  overflow: hidden;
  background: url(/img/facts/page2.svg) 50% 50% / cover;

  &__right {
    @extend .flex__center__center;
    flex-direction: column;
    position: absolute;
    height: 100%;
    width: 525px;
    left: 50%;
    bottom: 0;

    @media (min-width: 990px) and (max-width: 1199px) {
      width: 480px;
    }
  }

  &__wrap {
    @extend .flex__wrap, .flex__center__space-between;
  }

  &__item {
    width: 222px;

    &:nth-child(2) {
      margin-top: 50px;
    }

    &:nth-child(3) {
      margin-top: -50px;
    }

    h2 {
      padding-left: 10px;
      font-family: $font__secondary;
      font-size: 32px;
      font-weight: 800;

      span {
        font-family: $font__secondary;
        font-size: 75px;
      }
    }
  }
}
</style>
